<template>
  <div>
    <table-widget
      :items="proposals"
      :perPage="perPage"
      :totalRows="totalRows"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <!-- <template v-slot:buttons>
        <b-button v-if="manageProposals" class="mx-2" variant="primary" v-b-modal.proposals-modal @click="selectedProposals = null"><font-awesome-icon icon="plus"/> Manage Proposals</b-button>
      </template> -->
      <template v-slot:content>
        <b-table
          striped
          :items="proposals"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          small
          show-empty
          empty-filtered-text="There are no proposals that match your search criteria."
        >
          <template v-slot:cell(proposalNumber)="data">
            <a :href="proposalUrl + data.item.id" target="_blank">{{
              data.item.proposalNumber
            }}</a>
          </template>
          <template v-slot:cell(proposalTitle)="data">
            <a :href="proposalUrl + data.item.id" target="_blank">{{
              data.item.proposalTitle
            }}</a>
          </template>
          <template v-slot:cell(primaryInvestigator)="data">
            <span v-if="data.item.primaryInvestigator"
              >{{ data.item.primaryInvestigator.firstName }}
              {{ data.item.primaryInvestigator.lastName }}</span
            >
          </template>
          <template v-slot:cell(source)="data">
            <span v-if="data.item.source">{{ data.item.source.name }}</span>
          </template>
          <template v-slot:cell(originatingSponsor)="data">
            <span v-if="data.item.originatingSponsor">{{
              data.item.originatingSponsor.name
            }}</span>
          </template>
          <template v-slot:cell(details)="data">
            <router-link
              :to="{ name: 'proposal', params: { proposalId: data.item.id } }"
              >Details</router-link
            >
          </template>
          <template v-slot:cell(startDate)="data">
            {{ data.item.startDate | formatDate }}
          </template>
          <template v-slot:cell(endDate)="data">
            {{ data.item.endDate | formatDate }}
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      items: [],
      fields: [
        { key: "proposalTitle", label: "Title" },
        { key: "primaryInvestigator" },
        { key: "source" },
        { key: "status" },
        { key: "startDate", sortable: true },
        { key: "endDate", sortable: true, label: "Last Updated" },
        { key: "originatingSponsor" },
        { key: "details", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedProposals: null,
      showProposalsForm: false,
    };
  },

  props: {
    proposals: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    manageProposals: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
  },

  components: {
    "table-widget": TableWidget,
  },
  computed: {
    proposalUrl: function () {
      return process.env.NODE_ENV !== "production"
        ? "https://communitypartnerships-dev.chs.asu.edu/proposals/"
        : "https://communitypartnerships.chs.asu.edu/proposals/";
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateProposals(proposals) {
      this.items = proposals;
    },
    saveProposals() {
      event.preventDefault();
      this.$emit("saveProposals", this.items);
      this.showProposalsForm = false;
    },
    displayProposal(proposal) {
      return (
        proposal.proposalTitle +
        " (" +
        proposal.proposalNumber +
        ")<br/>" +
        "PI: " +
        proposal.primaryInvestigator.firstName +
        " " +
        proposal.primaryInvestigator.lastName
      );
    },
  },
  watch: {
    proposals: function () {
      if (this.proposals) {
        this.items = _.clone(this.proposals);
      }
    },
  },
  created() {
    if (this.proposals) {
      this.items = _.clone(this.proposals);
    }
  },
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.proposal-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.proposal-list {
  font-size: 16px;
}
table {
  font-size: 10pt;
}
</style>
